(function () {

  function loadScript(src, cb) {
    var s = document.createElement('script');
    s.src = src; s.onload = cb;
    document.head.appendChild(s);
  }

  function injectMarkup() {
    var hw = document.querySelector('.hero-wrapper');
    if (!hw || hw.querySelector('.sw-hero-overlay')) return;

    var heroEl = hw.querySelector('.hero');
    if (heroEl) heroEl.style.minHeight = '100svh';

    hw.insertAdjacentHTML('beforeend', [
      '<div class="sw-hero-overlay">',
        '<div class="sw-warm-overlay"></div>',
        '<div class="sw-orb sw-orb-1"></div>',
        '<div class="sw-orb sw-orb-2"></div>',
        '<div class="sw-corner sw-tl"></div>',
        '<div class="sw-corner sw-tr"></div>',
        '<div class="sw-corner sw-bl"></div>',
        '<div class="sw-corner sw-br"></div>',
        '<div class="sw-content">',
          '<div class="sw-rule sw-rule-top"></div>',
          '<p class="sw-eyebrow">The Art of Order</p>',
          '<div class="sw-brand">',
            '<span>S</span><span>O</span><span>R</span><span>T</span><span>E</span><span>D</span>',
          '</div>',
          '<p class="sw-tagline"></p>',
          '<div class="sw-rule sw-rule-bottom"></div>',
          '<div class="sw-cta-wrap">',
            '<a href="/collections/all" class="sw-cta">',
              '<span>Shop the Products</span>',
              '<span class="sw-arr">&#x2192;</span>',
            '</a>',
          '</div>',
        '</div>',
        '<div class="sw-spotlight"></div>',
        '<div class="sw-scanline"></div>',
      '</div>'
    ].join(''));
  }

  function animate() {
    var OL  = document.querySelector('.sw-hero-overlay');
    var mg  = document.querySelector('.hero-wrapper .hero__media-grid');
    if (!OL) return;

    var eyebrow   = OL.querySelector('.sw-eyebrow');
    var brand     = OL.querySelector('.sw-brand');
    var letters   = Array.from(OL.querySelectorAll('.sw-brand span'));
    var tagline   = OL.querySelector('.sw-tagline');
    var ctaWrap   = OL.querySelector('.sw-cta-wrap');
    var corners   = OL.querySelectorAll('.sw-corner');
    var ruleTop   = OL.querySelector('.sw-rule-top');
    var ruleBot   = OL.querySelector('.sw-rule-bottom');
    var spotlight = OL.querySelector('.sw-spotlight');
    var heroImg   = mg && (mg.querySelector('img') || mg.querySelector('.hero__media'));

    gsap.set(eyebrow, { opacity: 0, y: 20 });
    gsap.set(brand,   { opacity: 0 });
    gsap.set(letters, { opacity: 0, y: 26 });
    gsap.set(tagline, { opacity: 0 });
    gsap.set(ctaWrap, { opacity: 0, y: 14 });
    gsap.set(corners, { opacity: 0 });
    gsap.set(ruleTop, { scaleX: 0, transformOrigin: 'center' });
    gsap.set(ruleBot, { scaleX: 0, transformOrigin: 'center' });
    if (mg) gsap.set(mg, { opacity: 0 });

    if (heroImg) {
      gsap.fromTo(heroImg,
        { scale: 1.07, transformOrigin: '60% 50%' },
        { scale: 1.0, duration: 18, ease: 'none', yoyo: true, repeat: -1 }
      );
    }

    gsap.to('.sw-orb-1', { x: 35, y: -28, duration: 11, ease: 'sine.inOut', yoyo: true, repeat: -1 });
    gsap.to('.sw-orb-2', { x: -45, y: 32, duration: 14, ease: 'sine.inOut', yoyo: true, repeat: -1 });
    gsap.fromTo('.sw-scanline', { top: '-2px' }, { top: '100%', duration: 8, ease: 'none', repeat: -1, delay: 4 });

    if (mg) gsap.to(mg, { opacity: 1, duration: 1.8, ease: 'power2.inOut', delay: 0.15 });
    gsap.to(corners, { opacity: 1, duration: 0.55, stagger: 0.1, delay: 0.9 });

    function resetText() {
      gsap.set(eyebrow, { opacity: 0, y: 20 });
      gsap.set(brand,   { opacity: 0 });
      gsap.set(letters, { opacity: 0, y: 26 });
      tagline.textContent = '';
      gsap.set(tagline, { opacity: 0 });
      gsap.set(ctaWrap, { opacity: 0, y: 14 });
      gsap.set(ruleTop, { scaleX: 0 });
      gsap.set(ruleBot, { scaleX: 0 });
    }

    function textSequence() {
      resetText();
      var tl = gsap.timeline();

      tl.to(ruleTop,  { scaleX: 1, duration: 1.0, ease: 'power2.inOut' }, 0.2);
      tl.to(ruleBot,  { scaleX: 1, duration: 1.0, ease: 'power2.inOut' }, 0.38);
      tl.to(eyebrow,  { opacity: 1, y: 0, duration: 0.85, ease: 'power3.out' }, 0.7);

      tl.to(brand, { opacity: 1, duration: 0.05 }, 1.5);
      letters.forEach(function(l, i) {
        tl.to(l, { opacity: 1, y: 0, duration: 0.65, ease: 'power3.out' }, 1.6 + i * 0.08);
      });

      tl.add(function() {
        var txt = 'where everything finds its place.';
        gsap.to(tagline, { opacity: 1, duration: 0.6 });
        var i = 0;
        var iv = setInterval(function() {
          tagline.textContent = txt.slice(0, ++i);
          if (i >= txt.length) clearInterval(iv);
        }, 44);
      }, 3.0);

      tl.to(ctaWrap, { opacity: 1, y: 0, duration: 0.9, ease: 'power3.out' }, 4.2);

      tl.add(function(){}, 9.5);

      tl.to([ruleTop, ruleBot, eyebrow], { opacity: 0, duration: 0.55 }, 9.5);
      letters.forEach(function(l, i) {
        tl.to(l, { opacity: 0, y: -10, duration: 0.45 }, 9.55 + i * 0.06);
      });
      tl.to([tagline, ctaWrap], { opacity: 0, duration: 0.55 }, 9.7);

      tl.add(function() { setTimeout(textSequence, 1400); }, 10.6);
    }

    setTimeout(textSequence, 1100);

    OL.addEventListener('mousemove', function(e) {
      var r = OL.getBoundingClientRect();
      gsap.to(spotlight, { left: e.clientX - r.left, top: e.clientY - r.top, opacity: 1, duration: 0.55 });
    });
    OL.addEventListener('mouseleave', function() {
      gsap.to(spotlight, { opacity: 0, duration: 0.55 });
    });
  }

  function run() { injectMarkup(); animate(); }

  loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js', function() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  });

})();
